// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { withHandlers } from '../../../node_module_clones/recompose';
import classNames from 'classnames';

const enhance = withHandlers({
    setTab:
        ({ setTab, tabId, disabled }) =>
        () =>
            !disabled && setTab(tabId),
});

const Tab = ({ children, activeTab, tabId, className, setTab, disabled }) => (
    <div className={classNames('Tab', className, { disabled, active: activeTab === tabId })} onClick={setTab}>
        {children}
    </div>
);

Tab.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
    setTab: PropTypes.func.isRequired,
    tabId: PropTypes.string.isRequired,
    activeTab: PropTypes.string.isRequired,
    className: PropTypes.string,
    disabled: PropTypes.bool,
};

export default enhance(Tab);
